import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { Feedback } from './feedbacks-reducer';
import type {
    LeaveFeedbackItemViewModel,
    PagedFeedback
} from './leave-feedback';
import qs from 'qs';

const leaveFeedbackApi = createApi({
    reducerPath: 'leaveFeedbackApi',
    tagTypes: ['PagedFeedback'],
    baseQuery: fetchBaseQuery({
        baseUrl: ''
    }),
    endpoints: (builder) => ({
        getFeedbackItems: builder.query<
            { items: LeaveFeedbackItemViewModel[] },
            { role: string; transactionIds: string[] }
        >({
            query: ({ role, transactionIds }) => ({
                url: `/my/leave-feedback/${role}/items?${qs.stringify({
                    ids: transactionIds
                })}`,
                method: 'GET'
            })
        }),
        getAllFeedbackItems: builder.query<
            PagedFeedback,
            { role: string; skip?: number; take?: number }
        >({
            providesTags: ['PagedFeedback'],
            query: ({ role, skip = 0, take = 10 }) => ({
                url: `/my/leave-feedback/${role}/pageditems`,
                params: {
                    skip,
                    take
                }
            })
        }),
        submitFeedback: builder.mutation<
            {
                failures?: {
                    errorCode: string;
                    transactionId: number;
                }[];
            },
            {
                role: string;
                data: Omit<Feedback, 'errorMessageTranslationKeys'>[];
            }
        >({
            invalidatesTags: ['PagedFeedback'],
            query: ({ role, data }) => ({
                url: `/my/leave-feedback/${role}/save`,
                method: 'POST',
                body: data
            })
        })
    })
});

export const {
    useGetFeedbackItemsQuery,
    useGetAllFeedbackItemsQuery,
    useSubmitFeedbackMutation
} = leaveFeedbackApi;

export default leaveFeedbackApi;
